const educationStageLabels: Record<string, string> = {
  CURSO_TECNICO: 'Curso Técnico',
  EDUCACAO_INFANTIL: 'Educação Infantil',
  EJA: 'Educação de Jovens e Adultos',
  ENSINO_FUNDAMENTAL_INICIAL: 'Ensino Fundamental - Anos Iniciais',
  ENSINO_FUNDAMENTAL_FINAL: 'Ensino Fundamental - Anos Finais',
  ENSINO_FUNDAMENTAL: 'Ensino Fundamental',
  ENSINO_MEDIO: 'Ensino Médio',
}

export const formatEducationStage = (stage: string): string => {
  return educationStageLabels[stage] || stage
}

export const formatEducationStages = (stages: string[] | string): string => {
  if (!stages) return ''

  const stageArray = Array.isArray(stages)
    ? stages
    : stages.split(',').map(s => s.trim())

  return stageArray
    .map(stage => formatEducationStage(stage))
    .filter(Boolean)
    .join(', ')
}

export const formatEducationStagesByIds = (
  ids: string,
  idToNameMap: Record<string, string>
): string => {
  if (!ids) {
    return ''
  }

  const idArray = ids
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
  const names = idArray.map(id => idToNameMap[String(id)] ?? id)

  return Array.from(new Set(names)).join(', ')
}

const dependencyLabels: Record<string, string> = {
  '1': 'Federal',
  '2': 'Estadual',
  '3': 'Municipal',
  '4': 'Privada',
}

export const formatDependency = (dependency: string): string => {
  return dependencyLabels[dependency] || dependency
}

const locationLabels: Record<string, string> = {
  '1': 'Urbana',
  '2': 'Rural',
}

export const formatLocation = (location: string): string => {
  return locationLabels[location] || location
}
